/* SOWTH theme behaviour. Mobile nav, gallery, message selector, base selector, cart. */
(function () {
  'use strict';

  /* ---------- mobile navigation ---------- */
  var hdr = document.querySelector('[data-hdr]');
  var burger = document.querySelector('[data-burger]');
  if (hdr && burger) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- product configurator ---------- */
  var root = document.querySelector('[data-keepsake]');
  if (!root) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('sowth-data').textContent); } catch (e) { return; }

  var MESSAGES = DATA.messages || [];
  var BASES = DATA.bases || [];
  if (!MESSAGES.length) return;

  var cur = DATA.initial || 0;
  if (cur < 0 || cur >= MESSAGES.length) cur = 0;
  var base = 0;

  /* ---------- gallery ---------- */
  var gmain = root.querySelector('[data-gmain]');
  var thumbs = root.querySelectorAll('[data-th]');
  var slides = root.querySelectorAll('[data-slide]');
  var swipe = root.querySelector('[data-swipe]');
  var dots = root.querySelectorAll('[data-dot]');
  var shot = 0;

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function shotOf(url, alt, w) {
    return '<img src="' + esc(url) + '" alt="' + esc(alt) +
      '" width="' + w + '" height="' + w + '" loading="lazy" decoding="async">';
  }
  function altFor(m) {
    var b = BASES[base] || {};
    return 'The Keepsake Set: a Love Knot necklace on a clear acrylic panel printed "' +
      (m.line || '') + '", in a wooden ' + (b.label || '') + ' base.';
  }

  /* Each message is its own product with its own photographs, one set per LED
     base, so the gallery is rebuilt whenever either choice changes. */
  function shotsFor(m, bi) {
    var g = m && m.images;
    if (!g || !g.length) return [];
    return (g[bi] && g[bi].length) ? g[bi] : (g[0] || []);
  }

  function paintGallery() {
    var m = MESSAGES[cur] || {};
    var imgs = shotsFor(m, base);

    if (imgs.length) {
      if (shot >= imgs.length) shot = 0;
      var alt = altFor(m);
      if (gmain) gmain.innerHTML = shotOf(imgs[shot], alt, 1000);
      Array.prototype.forEach.call(thumbs, function (t, i) {
        t.hidden = i >= imgs.length;
        if (i < imgs.length) t.innerHTML = shotOf(imgs[i], alt, 110);
        t.setAttribute('aria-pressed', i === shot);
      });
      Array.prototype.forEach.call(slides, function (s, i) {
        s.hidden = i >= imgs.length;
        if (i < imgs.length) s.innerHTML = shotOf(imgs[i], alt, 1000);
      });
      Array.prototype.forEach.call(dots, function (d, i) {
        d.hidden = i >= imgs.length;
        d.classList.toggle('on', i === shot);
      });
      return;
    }

    if (gmain && slides[shot]) gmain.innerHTML = slides[shot].innerHTML;
    Array.prototype.forEach.call(thumbs, function (t, i) { t.setAttribute('aria-pressed', i === shot); });
    Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('on', i === shot); });
  }
  Array.prototype.forEach.call(thumbs, function (t, i) {
    t.addEventListener('click', function () { shot = i; paintGallery(); });
  });
  if (swipe) {
    swipe.addEventListener('scroll', function () {
      var i = Math.round(swipe.scrollLeft / swipe.clientWidth);
      if (i !== shot) { shot = i; paintGallery(); }
    }, { passive: true });
  }

  /* ---------- variant resolution ---------- */
  function variantFor(mi, bi) {
    var m = MESSAGES[mi], b = BASES[bi];
    if (!m.variants || !m.variants.length) return null;
    var needle = String(b.match || b.label).toLowerCase();
    for (var i = 0; i < m.variants.length; i++) {
      if (String(m.variants[i].title).toLowerCase().indexOf(needle) !== -1) return m.variants[i];
    }
    return m.variants.length === 1 ? m.variants[0] : null;
  }

  /* ---------- selectors ---------- */
  var idx = root.querySelectorAll('[data-msg]');
  var counter = root.querySelector('[data-counter]');
  var selLine = root.querySelector('[data-selected-line]');
  var selName = root.querySelector('[data-selected-name]');
  var WORDS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight',
               'Nine', 'Ten', 'Eleven', 'Twelve'];

  function selectMessage(i) {
    cur = i;
    var m = MESSAGES[i];
    if (counter) counter.textContent = (WORDS[i] || (i + 1)) + ' of ' + MESSAGES.length;
    Array.prototype.forEach.call(idx, function (c, k) { c.setAttribute('aria-pressed', k === i); });
    if (idx[i] && idx[i].scrollIntoView) idx[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    if (selLine) selLine.textContent = m.line;
    if (selName) selName.textContent = m.label;
    shot = 0;
    paintGallery();
    hideSaid();
    syncButtons();
  }
  Array.prototype.forEach.call(idx, function (b, i) {
    b.addEventListener('click', function () { selectMessage(i); });
  });

  var bops = root.querySelectorAll('[data-base]');
  Array.prototype.forEach.call(bops, function (b, i) {
    b.addEventListener('click', function () {
      base = i;
      Array.prototype.forEach.call(bops, function (x, k) { x.setAttribute('aria-pressed', k === i); });
      paintGallery();
      hideSaid();
      syncButtons();
    });
  });

  /* ---------- add to cart ---------- */
  var atc = root.querySelector('[data-atc]');
  var satc = document.querySelector('[data-satc]');
  var said = root.querySelector('[data-said]');
  var stickline = document.querySelector('[data-stickline]');
  var cartCounts = document.querySelectorAll('[data-cart-count]');

  function hideSaid() { if (said) said.classList.remove('on'); }

  function syncButtons() {
    var v = variantFor(cur, base);
    var ok = !!(v && v.available);
    [atc, satc].forEach(function (b) {
      if (!b) return;
      b.disabled = !ok;
      if (b === atc) b.textContent = ok ? DATA.addLabel : 'Not available yet';
    });
    if (stickline) {
      stickline.textContent = DATA.price + ', ' + MESSAGES[cur].label + ', ' + BASES[base].label;
    }
  }

  function addToCart() {
    var v = variantFor(cur, base);
    if (!v) return;
    var m = MESSAGES[cur], b = BASES[base];
    [atc, satc].forEach(function (x) { if (x) x.disabled = true; });

    fetch(DATA.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch(DATA.routes.cart + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(cartCounts, function (el) { el.textContent = cart.item_count; });
        if (said) {
          said.innerHTML = '<b>Added to your bag.</b> ' + m.label + ', "' + m.line +
            '" with the ' + b.label + ' base.';
          said.classList.add('on');
        }
      })
      .catch(function () {
        if (said) {
          said.innerHTML = '<b>Something went wrong.</b> Please try again, or refresh the page.';
          said.classList.add('on');
        }
      })
      .then(function () { syncButtons(); });
  }

  if (atc) atc.addEventListener('click', addToCart);
  if (satc) satc.addEventListener('click', addToCart);

  selectMessage(cur);
})();
